import { useState, useEffect } from "react";

export function useMobileMode() {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const isPWA =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;

      const isTouch = navigator.maxTouchPoints > 0;
      const isSmall = window.innerWidth <= 768;

      // mobilne tylko gdy mały ekran
      // albo PWA na małym/dotykowym urządzeniu
      const isMobile = isSmall || (isPWA && isTouch);

      setMobile(isMobile);
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return mobile;
}